import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { AcceleratorEnrollment } from '@interfaces';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(util: UtilityService): GridSetup<AcceleratorEnrollment> {
	return {
		rowName: { singular: 'Enrollment', plural: 'Enrollments' },
		getRowKey: row => '' + row.courseEnrollmentId,
		stateKey: 'programs-experience-courses-accelerator-enrollments-grid',
		renderRowClasses: row => [],
		multiselect: false,
		actions: getActions(),
		buttons: getButtons(),
		columns: getColumns(util),
	}
}
